import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { Pill } from 'ui-components/components/pill';

import { useSellerFormattedDate } from '../../../../../hooks/use-datetime-formats';
import { PlanLineItemCost } from './plan-line-item-cost';

import styles from './style.module.less';
import messages from './messages';

export const SubscriptionCardSectionLineItem = ({ lineItem }) => {
  const deactivationDt = useSellerFormattedDate(lineItem?.deactivationDateTimeUtc);
  return (
    <FlexRow className={classnames(styles['plan-info'], styles['new-info-row'])}>
      <FlexRow className={styles['plan-line-item-label']}>
        <Text textType={TextType.Paragraph} value={lineItem.nameMessageDescriptor} />
        {lineItem.isTrial && !lineItem.isIncludedInPlan && !lineItem.deactivationDateTimeUtc && (
          <Text className={styles['is-trial']} textType={TextType.Paragraph} value={messages.trial} />
        )}
        {lineItem.deactivationDateTimeUtc && (
          <Pill label={<FormattedMessage {...messages.deactivationDate} values={{ deactivationDt }} />} theme='neutral' />
        )}
      </FlexRow>
      <PlanLineItemCost
        isIncludedInPlan={lineItem.isIncludedInPlan || lineItem.isAlphaUser}
        isTrial={lineItem.isTrial}
        price={lineItem.price}
      />
    </FlexRow>
  );
};

SubscriptionCardSectionLineItem.propTypes = {
  lineItem: PropTypes.object.isRequired,
};
